/* global gsap */

/**
 * Linear sequence animation
 * @param {Element} element - element to animate
 */
function linearSequenceAnimation(element) {
  const circle = {
    duration: 0.25,
    opacity: 0,
    scale: 0.25,
    transformOrigin: 'center',
  };

  const tl = gsap.timeline({
    repeat: -1,
    yoyo: true,
    repeatDelay: 0.5,
  });

  const leftCircleTl = gsap.timeline();

  leftCircleTl.from('.left-diamond', circle)
    .from('.left-circle', circle, '<+=0.1');


  const middleCircleTl = gsap.timeline();

  middleCircleTl.from('.middle-diamond', circle)
    .from('.middle-circle', circle, '<+=0.1');

  const rightCircleTl = gsap.timeline();

  rightCircleTl.from('.right-circle-center', circle)
    .from('.right-circle', circle, '<+=0.1')
    .from('.right-circle-dot', {
      opacity: 0,
      scale: 0.25,
      stagger: 0.05,
      transformOrigin: 'center',
    }, '>-0.5').from('.right-curve-bottom', {
      duration: 0.25,
      drawSVG: '0%',
    }, '<').from('.right-curve-left', {
      duration: 0.25,
      drawSVG: '0%',
    }, '>');

  const lineTL = gsap.timeline({
    reversed: true,
  });

  lineTL.fromTo('.left-line',
    {
      drawSVG: '0% 100%',
    },
    {
      duration: 0.5,
      drawSVG: '100% 100%',
    }
  ).fromTo('.right-line',
    {
      drawSVG: '0% 100%',
    },
    {
      duration: 0.5,
      drawSVG: '100% 100%',
    }, '<-0.15'
  );

  tl.add(middleCircleTl);
  tl.add(rightCircleTl, '>-0.2');
  tl.add(leftCircleTl, '<');
  tl.add(lineTL, '<-0.1');
}

export {linearSequenceAnimation};
